export default __webpack_public_path__ + "static/media/payment_processing_desktop.9a1165f3.mp4";